<template>
  <div>
    <HeaderComponent/>
    <main class="about-page py-8 px-4 lg:px-16">
      <section class="about-intro mb-16">
        <h1 class="text-3xl font-bold text-gray-800 mb-6">About Us</h1>
        <p class="text-gray-700 mb-4">
          🌐 Arrify is a dynamic IT company based in India, dedicated to providing a comprehensive range of IT services
          that empower businesses to thrive in the digital landscape. With a strong focus on Salesforce Development and
          WordPress, we cater to the unique needs of small and medium-sized enterprises (SMEs) around the globe.
        </p>
        <p class="text-gray-700 mb-4">
          💼 Our team at Arrify is composed of skilled Salesforce developers and consultants who are passionate about
          delivering customized solutions that drive growth and efficiency. Whether you're looking to enhance your
          Salesforce capabilities, streamline your business processes, or create a robust online presence through
          WordPress, we have the expertise to make it happen.
        </p>
        <p class="text-gray-700">
          🚀 At Arrify, we believe that <strong class="font-semibold">growing your business is our business</strong>. We
          work closely with our clients to understand their specific goals and challenges, offering tailored services
          that not only meet but exceed expectations. Our commitment to quality, innovation, and customer satisfaction
          has made us a trusted partner for businesses looking to leverage technology for success.
        </p>
      </section>

      <section class="what-we-do mb-12">
        <h2 class="text-2xl font-bold text-gray-800 mb-4">What We Do</h2>
        <ul class="space-y-4">
          <li>🔧 <strong class="font-semibold">Salesforce Implementation:</strong> Deploy Salesforce solutions tailored
            to your business needs, ensuring improved ROI and streamlined processes.
          </li>
          <li>⚙️ <strong class="font-semibold">Salesforce Setup & Configuration:</strong> Configure and set up
            Salesforce for a quick start, customized to meet your specific requirements.
          </li>
          <li>💻 <strong class="font-semibold">Salesforce Custom Development:</strong> Develop and deploy out-of-the-box
            solutions using code, ensuring your Salesforce environment is perfectly aligned with your goals.
          </li>
          <li>🔗 <strong class="font-semibold">Salesforce Integration:</strong> Seamlessly connect Salesforce to any
            third-party system using APIs, enhancing your business's efficiency and data flow.
          </li>
          <li>🛠️ <strong class="font-semibold">Salesforce Support & Maintenance:</strong> Provide regular support and
            maintenance to ensure your deployed Salesforce solutions continue to perform optimally.
          </li>
          <li>🌐 <strong class="font-semibold">WordPress Portal using Salesforce:</strong> Design and develop
            customer/client portals in WordPress, leveraging Salesforce data to create a cohesive and functional
            experience.
          </li>
        </ul>
      </section>

      <section class="how-we-work">
        <h2 class="text-2xl font-bold text-gray-800 mb-4">How We Work</h2>
        <ul class="space-y-4">
          <li>🔍 <strong class="font-semibold">Requirement:</strong> We start by understanding your business and the
            challenges you face. This helps us provide the most effective solution tailored to your needs.
          </li>
          <li>📝 <strong class="font-semibold">Designing:</strong> Based on your requirements and timeline, we suggest
            the minimum viable solution so you can start benefiting from it as soon as possible.
          </li>
          <li>🚧 <strong class="font-semibold">Implementation:</strong> We implement the proposed solution, which
            includes development, rigorous testing, and seamless deployment.
          </li>
          <li>🔄 <strong class="font-semibold">Feedback:</strong> After deployment, we gather your feedback and address
            any issues or bugs to ensure the solution works perfectly.
          </li>
          <li>🔁 <strong class="font-semibold">Iterate:</strong> We continue refining the solution through iterative
            cycles until it fully meets your expectations and business needs.
          </li>
        </ul>
      </section>
    </main>
    <FooterComponent/>
  </div>
</template>

<script setup>
import {useCommonHead} from '../composables/useCommonHead';
import HeaderComponent from "../components/Header.vue";
import FooterComponent from "../components/Footer.vue";

const pageTitle = 'About Us - Arrify';
const pageDescription = 'Learn about Arrify, a dynamic IT company based in India, specializing in Salesforce Development and WordPress solutions for SMEs globally.';
const currentUrl = '/about';

useCommonHead(pageTitle, pageDescription, currentUrl);
</script>

<style scoped>
.about-page {
  @apply py-8 px-4 lg:px-16;
}

.about-intro {
  @apply mb-16;
}

h1 {
  @apply text-3xl font-bold text-gray-800 mb-6;
}

h2 {
  @apply text-2xl font-bold text-gray-800 mb-4;
}

p {
  @apply text-gray-700 mb-4;
}

ul {
  @apply space-y-4;
}

strong {
  @apply font-semibold;
}
</style>
